import axios from 'axios';

const API_HOST_URL = process.env.REACT_APP_API_URL

export const getLeaveType = async(id: number) =>{
    let leaveType: any;
    await axios.get(`${API_HOST_URL}/api/leave/leavetype/${id}`)
      .then(res => {
          leaveType = res.data
          console.log("fetched leave type: ", leaveType);
      })
      .catch(error => {
          console.log(error);
        })
      return leaveType;
  }
